/* Viva Melhor · Nova home (componentes vm-*) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function onCartUpdate(callback) {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      return subscribe(PUB_SUB_EVENTS.cartUpdate, callback);
    }
    return function () {};
  }

  function cartJsonUrl() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base.replace(/\/$/, '') + '.js';
  }

  /* ------------------------------------------------------------------
     Cabeçalho: fixo, ocultar ao descer, contador do carrinho
     ------------------------------------------------------------------ */
  if (!customElements.get('vm-header')) {
    customElements.define('vm-header', class VmHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section') || this;
        this.mode = this.dataset.sticky || 'on-scroll-up';
        this.countEls = Array.prototype.slice.call(this.querySelectorAll('[data-vm-cart-count]'));
        this.cartLink = this.querySelector('[data-vm-cart-link]');
        this.sink = this.querySelector('#cart-icon-bubble');
        this.lastY = window.pageYOffset || 0;
        this.isHidden = false;

        this.onScroll = this.onScroll.bind(this);
        if (this.mode === 'on-scroll-up') window.addEventListener('scroll', this.onScroll, { passive: true });

        if (this.sink && 'MutationObserver' in window) {
          this.observer = new MutationObserver(this.readSink.bind(this));
          this.observer.observe(this.sink, { childList: true, subtree: true, characterData: true });
        }

        this.unsubscribe = onCartUpdate(function () {
          this.show(true);
          this.refreshCount();
        }.bind(this));

        this.onPageShow = function (event) {
          if (!event.persisted) return;
          this.closeMenu(true);
          this.refreshCount();
        }.bind(this);
        window.addEventListener('pageshow', this.onPageShow);

        this.onCartClick = this.onCartClick.bind(this);
        if (this.cartLink) this.cartLink.addEventListener('click', this.onCartClick);

        this.menu = this.querySelector('[data-vm-menu]');
        this.menuBtn = this.querySelector('[data-vm-menu-open]');
        if (this.menu && this.menuBtn) this.bindMenu();

        this.bindMobilePlaceholder();
        this.bindMega();
      }

      /* Submenu do computador: abre ao passar o rato (CSS); aqui fecha com Esc
         e, nos ecrãs táteis grandes, o primeiro toque abre o painel em vez de navegar. */
      bindMega() {
        this.nav = this.querySelector('[data-vm-nav]');
        if (!this.nav || !this.nav.querySelector('[data-vm-mega]')) return;
        var nav = this.nav;
        this.mqHover = window.matchMedia ? window.matchMedia('(hover: hover)') : null;
        /* Os painéis vêm em <template>: no telemóvel nunca entram na página (menos DOM e
           nenhuma imagem extra); no computador são criados quando o rato chega ao menu ou
           num momento livre depois de carregar. */
        var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
        var hydrated = false;
        var hydrate = function () {
          if (hydrated || (mqDesk && !mqDesk.matches)) return;
          hydrated = true;
          Array.prototype.forEach.call(nav.querySelectorAll('template[data-vm-mega-tpl]'), function (tpl) {
            tpl.parentNode.replaceChild(tpl.content.cloneNode(true), tpl);
          });
        };
        nav.addEventListener('pointerenter', hydrate);
        nav.addEventListener('focusin', hydrate);
        nav.addEventListener('touchstart', hydrate, { passive: true });
        if (mqDesk) {
          var onDesk = function (event) { if (event.matches) hydrate(); };
          if (mqDesk.addEventListener) mqDesk.addEventListener('change', onDesk);
          else if (mqDesk.addListener) mqDesk.addListener(onDesk);
          if (mqDesk.matches) {
            if ('requestIdleCallback' in window) window.requestIdleCallback(hydrate, { timeout: 4000 });
            else window.setTimeout(hydrate, 2500);
          }
        }
        var items = Array.prototype.slice.call(nav.querySelectorAll('.vm-header__nav-item--mega'));
        var closeAll = function (except) {
          items.forEach(function (item) { if (item !== except) item.classList.remove('is-open'); });
        };
        this.onMegaKey = function (event) {
          if (event.key !== 'Escape' && event.keyCode !== 27) return;
          if (!nav.contains(document.activeElement) && !nav.querySelector('.is-open')) return;
          closeAll();
          nav.classList.add('is-mega-off');
          var item = document.activeElement && document.activeElement.closest ? document.activeElement.closest('.vm-header__nav-item') : null;
          var link = item ? item.querySelector('.vm-header__nav-link') : null;
          if (link) link.focus();
        };
        document.addEventListener('keydown', this.onMegaKey);
        var reset = function () { nav.classList.remove('is-mega-off'); };
        nav.addEventListener('mouseleave', function () { reset(); closeAll(); });
        nav.addEventListener('focusout', function (event) {
          if (!nav.contains(event.relatedTarget)) { reset(); closeAll(); }
        });
        nav.addEventListener('mousemove', function () { if (nav.classList.contains('is-mega-off') && !nav.contains(document.activeElement)) reset(); });
        var lastPointer = 'mouse';
        nav.addEventListener('pointerdown', function (event) { lastPointer = event.pointerType || 'mouse'; }, { passive: true });
        items.forEach(function (item) {
          var link = item.querySelector('.vm-header__nav-link');
          if (!link) return;
          link.addEventListener('click', function (event) {
            if (lastPointer !== 'touch' && lastPointer !== 'pen') return;
            if (!window.matchMedia || !window.matchMedia('(min-width: 990px)').matches) return;
            if (item.classList.contains('is-open')) return;
            event.preventDefault();
            reset();
            closeAll(item);
            item.classList.add('is-open');
          });
        });
        this.onDocTap = function (event) {
          if (!nav.contains(event.target)) closeAll();
        };
        document.addEventListener('click', this.onDocTap);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('pageshow', this.onPageShow);
        if (this.cartLink) this.cartLink.removeEventListener('click', this.onCartClick);
        if (this.observer) this.observer.disconnect();
        if (this.unsubscribe) this.unsubscribe();
        clearTimeout(this.countTimer);
        if (this.onMenuKey) document.removeEventListener('keydown', this.onMenuKey);
        if (this.onMegaKey) document.removeEventListener('keydown', this.onMegaKey);
        if (this.onDocTap) document.removeEventListener('click', this.onDocTap);
        if (this.menuOpen) document.documentElement.classList.remove('vm-scroll-lock');
        if (this.mqDesktop && this.onMq) {
          if (this.mqDesktop.removeEventListener) this.mqDesktop.removeEventListener('change', this.onMq);
          else if (this.mqDesktop.removeListener) this.mqDesktop.removeListener(this.onMq);
        }
        if (this.mqMobile && this.onMqMobile) {
          if (this.mqMobile.removeEventListener) this.mqMobile.removeEventListener('change', this.onMqMobile);
          else if (this.mqMobile.removeListener) this.mqMobile.removeListener(this.onMqMobile);
        }
      }

      /* Menu lateral para telemóvel e tablet */
      bindMenu() {
        this.menuPanel = this.menu.querySelector('.vm-menu__panel');
        this.onMenuKey = this.onMenuKey.bind(this);
        this.menuBtn.addEventListener('click', this.openMenu.bind(this));
        Array.prototype.forEach.call(this.menu.querySelectorAll('[data-vm-menu-close]'), function (el) {
          el.addEventListener('click', this.closeMenu.bind(this));
        }, this);
        if (window.matchMedia) {
          this.mqDesktop = window.matchMedia('(min-width: 990px)');
          this.onMq = function (event) { if (event.matches) this.closeMenu(true); }.bind(this);
          if (this.mqDesktop.addEventListener) this.mqDesktop.addEventListener('change', this.onMq);
          else if (this.mqDesktop.addListener) this.mqDesktop.addListener(this.onMq);
        }
      }

      openMenu() {
        if (!this.menu || this.menuOpen) return;
        this.menuOpen = true;
        this.show(true);
        this.menu.removeAttribute('inert');
        this.menu.setAttribute('aria-hidden', 'false');
        this.menu.classList.add('is-open');
        this.menuBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('vm-scroll-lock');
        document.addEventListener('keydown', this.onMenuKey);
        var close = this.menu.querySelector('.vm-menu__close');
        window.setTimeout(function () { (close || this.menuPanel).focus(); }.bind(this), 60);
      }

      closeMenu(skipFocus) {
        if (!this.menu || !this.menuOpen) return;
        this.menuOpen = false;
        this.menu.classList.remove('is-open');
        this.menu.setAttribute('aria-hidden', 'true');
        this.menu.setAttribute('inert', '');
        this.menuBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('vm-scroll-lock');
        document.removeEventListener('keydown', this.onMenuKey);
        if (skipFocus !== true) this.menuBtn.focus();
      }

      onMenuKey(event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
          event.preventDefault();
          this.closeMenu();
          return;
        }
        if (event.key !== 'Tab' && event.keyCode !== 9) return;
        var items = Array.prototype.filter.call(this.menuPanel.querySelectorAll('a[href], button:not([disabled])'), function (el) {
          return el.offsetWidth > 0 || el.offsetHeight > 0;
        });
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.menuPanel)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      /* Texto da pesquisa mais curto no telemóvel */
      bindMobilePlaceholder() {
        var input = this.querySelector('.vm-search__input[data-placeholder-mobile]');
        if (!input || !window.matchMedia) return;
        var mobileText = input.getAttribute('data-placeholder-mobile');
        if (!mobileText) return;
        var desktopText = input.getAttribute('placeholder') || '';
        this.mqMobile = window.matchMedia('(max-width: 749px)');
        this.onMqMobile = function () {
          input.setAttribute('placeholder', this.mqMobile.matches ? mobileText : desktopText);
        }.bind(this);
        this.onMqMobile();
        if (this.mqMobile.addEventListener) this.mqMobile.addEventListener('change', this.onMqMobile);
        else if (this.mqMobile.addListener) this.mqMobile.addListener(this.onMqMobile);
      }

      onCartClick(event) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          event.preventDefault();
          drawer.open(this.cartLink);
        }
      }

      isBusy() {
        if (this.menuOpen) return true;
        var active = document.activeElement;
        if (active && active !== document.body && this.contains(active)) {
          /* Só segura o cabeçalho quando se escreve ou se navega com o teclado (não depois de um toque) */
          if (/^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName)) return true;
          try { if (active.matches(':focus-visible')) return true; } catch (e) { return true; }
        }
        if (this.nav && this.nav.querySelector('.vm-header__nav-item.is-open')) return true;
        if (this.nav && this.mqHover && this.mqHover.matches && this.nav.matches(':hover')) return true;
        return !!this.querySelector('predictive-search[open], predictive-search[loading], .cart-notification.active');
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(function () {
          this.ticking = false;
          var y = Math.max(window.pageYOffset || 0, 0);
          var limit = this.section.offsetHeight + 120;
          if (y > this.lastY + 2 && y > limit) {
            if (!this.isBusy()) this.hide();
          } else if (y < this.lastY - 2 || y <= limit) {
            this.show();
          }
          this.lastY = y;
        }.bind(this));
      }

      hide() {
        if (this.isHidden) return;
        this.isHidden = true;
        this.section.classList.add('vm-header-hidden');
      }

      show(instant) {
        if (!this.isHidden) return;
        this.isHidden = false;
        var section = this.section;
        if (!instant) {
          section.classList.remove('vm-header-hidden');
          return;
        }
        /* Sem animação: o aviso do carrinho recebe o foco logo a seguir e
           o cabeçalho tem de estar já visível para o navegador não deslocar a página. */
        section.classList.add('vm-header-instant');
        section.classList.remove('vm-header-hidden');
        void section.offsetHeight;
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { section.classList.remove('vm-header-instant'); });
        });
      }

      /* API compatível com o cabeçalho do Dawn */
      reveal() { this.show(true); }

      setCount(count) {
        var n = parseInt(count, 10);
        if (isNaN(n)) return;
        this.countEls.forEach(function (el) {
          el.classList.toggle('is-empty', n === 0);
          if (el.textContent.trim() === String(n)) return;
          el.textContent = n;
          el.classList.remove('is-bump');
          void el.offsetWidth;
          el.classList.add('is-bump');
          setTimeout(function () { el.classList.remove('is-bump'); }, 280);
        });
        if (this.cartLink) {
          var label = this.dataset.cartLabel || 'Carrinho';
          this.cartLink.setAttribute('aria-label', label + ': ' + n + (n === 1 ? ' artigo' : ' artigos'));
        }
      }

      readSink() {
        if (!this.sink) return;
        var bubble = this.sink.querySelector('.cart-count-bubble');
        if (!bubble) { this.setCount(0); return; }
        var visible = bubble.querySelector('[aria-hidden="true"]');
        var n = visible ? parseInt(visible.textContent, 10) : NaN;
        if (isNaN(n)) this.refreshCount(); else this.setCount(n);
      }

      refreshCount() {
        clearTimeout(this.countTimer);
        this.countTimer = setTimeout(function () {
          fetch(cartJsonUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (response) { return response.ok ? response.json() : null; })
            .then(function (cart) { if (cart && typeof cart.item_count !== 'undefined') this.setCount(cart.item_count); }.bind(this))
            .catch(function () {});
        }.bind(this), 150);
      }
    });
  }

  /* ------------------------------------------------------------------
     Barra superior: rotação de mensagens no telemóvel
     ------------------------------------------------------------------ */
  if (!customElements.get('vm-rotator')) {
    customElements.define('vm-rotator', class VmRotator extends HTMLElement {
      connectedCallback() {
        this.items = Array.prototype.slice.call(this.querySelectorAll('.vm-topbar__item'));
        if (this.items.length < 2) return;
        this.index = Math.max(0, this.items.findIndex(function (el) { return el.classList.contains('is-active'); }));
        this.interval = Math.max(2000, parseInt(this.dataset.interval, 10) || 4000);
        this.mq = window.matchMedia('(max-width: 749px)');
        this.tick = this.tick.bind(this);
        this.restart = this.restart.bind(this);
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.restart); else this.mq.addListener(this.restart);
        if (designMode) {
          this.onSelect = function (event) {
            var i = this.items.indexOf(event.target);
            if (i > -1) { this.hold = true; this.show(i); this.restart(); }
          }.bind(this);
          this.onDeselect = function (event) {
            if (this.items.indexOf(event.target) > -1) { this.hold = false; this.restart(); }
          }.bind(this);
          document.addEventListener('shopify:block:select', this.onSelect);
          document.addEventListener('shopify:block:deselect', this.onDeselect);
        }
        this.restart();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.mq) { if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.restart); else this.mq.removeListener(this.restart); }
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
        if (this.onDeselect) document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }

      restart() {
        clearInterval(this.timer);
        if (this.mq.matches && !reduceMotion.matches && !this.hold) this.timer = setInterval(this.tick, this.interval);
      }

      show(i) {
        this.items[this.index].classList.remove('is-active');
        this.index = (i + this.items.length) % this.items.length;
        this.items[this.index].classList.add('is-active');
      }

      tick() {
        if (document.hidden) return;
        this.show(this.index + 1);
      }
    });
  }

  /* ------------------------------------------------------------------
     Hero: carrossel com transição suave
     ------------------------------------------------------------------ */
  if (!customElements.get('vm-hero-slider')) {
    customElements.define('vm-hero-slider', class VmHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-vm-slide]'));
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-vm-go]'));
        if (this.slides.length < 2) return;
        this.index = Math.max(0, this.slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
        this.delay = Math.max(3, parseFloat(this.dataset.speed) || 6.5) * 1000;
        this.autoplay = this.dataset.autoplay === 'true';

        var prev = this.querySelector('[data-vm-prev]');
        var next = this.querySelector('[data-vm-next]');
        if (prev) prev.addEventListener('click', function () { this.go(this.index - 1, true); }.bind(this));
        if (next) next.addEventListener('click', function () { this.go(this.index + 1, true); }.bind(this));
        this.tabs.forEach(function (tab) {
          tab.addEventListener('click', function () { this.go(parseInt(tab.dataset.vmGo, 10) || 0, true); }.bind(this));
        }, this);

        this.addEventListener('mouseenter', function () { this.hovering = true; this.stop(); }.bind(this));
        this.addEventListener('mouseleave', function () { this.hovering = false; this.start(); }.bind(this));
        this.addEventListener('focusin', function () { this.focused = true; this.stop(); }.bind(this));
        this.addEventListener('focusout', function (event) {
          if (!this.contains(event.relatedTarget)) { this.focused = false; this.start(); }
        }.bind(this));
        this.onVisibility = function () { if (document.hidden) this.stop(); else this.start(); }.bind(this);
        document.addEventListener('visibilitychange', this.onVisibility);

        this.bindSwipe();
        if (designMode) this.bindEditor();
        this.update();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
        if (this.onDeselect) document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }

      go(i, byUser) {
        var n = this.slides.length;
        this.index = ((i % n) + n) % n;
        this.update();
        if (byUser) this.start();
      }

      update() {
        this.slides.forEach(function (slide, i) {
          var active = i === this.index;
          slide.classList.toggle('is-active', active);
          if (active) { slide.removeAttribute('aria-hidden'); slide.removeAttribute('tabindex'); }
          else { slide.setAttribute('aria-hidden', 'true'); slide.setAttribute('tabindex', '-1'); }
        }, this);
        this.tabs.forEach(function (tab, i) {
          if (i === this.index) tab.setAttribute('aria-current', 'true'); else tab.removeAttribute('aria-current');
        }, this);
        var bg = this.slides[this.index].getAttribute('data-bg');
        if (bg) this.style.setProperty('--vm-cur-bg', bg);
      }

      start() {
        this.stop();
        if (!this.autoplay || reduceMotion.matches || this.hovering || this.focused || this.editorHold || document.hidden) return;
        this.timer = setInterval(function () { this.go(this.index + 1); }.bind(this), this.delay);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      bindSwipe() {
        var startX = null, startY = null, moved = false;
        this.addEventListener('touchstart', function (event) {
          var t = event.touches[0];
          startX = t.clientX; startY = t.clientY; moved = false;
          this.stop();
        }.bind(this), { passive: true });
        this.addEventListener('touchmove', function (event) {
          if (startX === null) return;
          var t = event.touches[0];
          var dx = t.clientX - startX, dy = t.clientY - startY;
          if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) moved = true;
        }, { passive: true });
        this.addEventListener('touchend', function (event) {
          if (startX === null) return;
          var dx = event.changedTouches[0].clientX - startX;
          if (moved && Math.abs(dx) > 40) {
            this.swipedAt = Date.now();
            this.go(this.index + (dx < 0 ? 1 : -1), true);
          } else {
            this.start();
          }
          startX = null;
        }.bind(this), { passive: true });
        this.addEventListener('click', function (event) {
          if (this.swipedAt && Date.now() - this.swipedAt < 450) { event.preventDefault(); event.stopPropagation(); }
        }.bind(this), true);
      }

      bindEditor() {
        this.onSelect = function (event) {
          var i = this.slides.indexOf(event.target);
          if (i > -1) { this.editorHold = true; this.stop(); this.go(i); }
        }.bind(this);
        this.onDeselect = function (event) {
          if (this.slides.indexOf(event.target) > -1) { this.editorHold = false; this.start(); }
        }.bind(this);
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:block:deselect', this.onDeselect);
      }
    });
  }

  /* ------------------------------------------------------------------
     Contagem decrescente (semanal até domingo às 23:59 ou data fixa)
     ------------------------------------------------------------------ */
  if (!customElements.get('vm-countdown')) {
    customElements.define('vm-countdown', class VmCountdown extends HTMLElement {
      connectedCallback() {
        this.d = this.querySelector('[data-d]');
        this.h = this.querySelector('[data-h]');
        this.m = this.querySelector('[data-m]');
        this.render();
        this.timer = setInterval(this.render.bind(this), 30000);
      }

      disconnectedCallback() { clearInterval(this.timer); }

      target() {
        var raw = (this.dataset.end || '').trim();
        if (raw) {
          var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);
          if (m) {
            var hasTime = typeof m[4] !== 'undefined';
            return new Date(+m[1], +m[2] - 1, +m[3], hasTime ? +m[4] : 23, hasTime ? +m[5] : 59, hasTime ? 0 : 59);
          }
        }
        var now = new Date();
        var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + ((7 - now.getDay()) % 7), 23, 59, 59);
        return end;
      }

      render() {
        var ms = Math.max(0, this.target() - new Date());
        var pad = function (v) { return (v < 10 ? '0' : '') + v; };
        if (this.d) this.d.textContent = Math.floor(ms / 864e5);
        if (this.h) this.h.textContent = pad(Math.floor(ms / 36e5) % 24);
        if (this.m) this.m.textContent = pad(Math.floor(ms / 6e4) % 60);
      }
    });
  }

  /* ------------------------------------------------------------------
     Carrossel horizontal (sintomas)
     ------------------------------------------------------------------ */
  if (!customElements.get('vm-carousel')) {
    customElements.define('vm-carousel', class VmCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-vm-track]');
        if (!this.track) return;
        this.prevBtn = this.querySelector('[data-vm-car-prev]');
        this.nextBtn = this.querySelector('[data-vm-car-next]');
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = Math.max(2000, parseInt(this.dataset.interval, 10) || 3200);
        this.holdUntil = 0;
        this.inView = !('IntersectionObserver' in window);

        if (this.prevBtn) this.prevBtn.addEventListener('click', function () { this.step(-1, false); this.hold(6000); }.bind(this));
        if (this.nextBtn) this.nextBtn.addEventListener('click', function () { this.step(1, true); this.hold(6000); }.bind(this));

        var holdShort = function () { this.hold(6000); }.bind(this);
        ['touchstart', 'pointerdown', 'wheel', 'focusin', 'keydown'].forEach(function (type) {
          this.track.addEventListener(type, holdShort, { passive: true });
        }, this);
        this.track.addEventListener('mouseenter', function () { this.holdUntil = Infinity; }.bind(this));
        this.track.addEventListener('mouseleave', function () { this.holdUntil = Date.now() + 1500; }.bind(this));

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entries) {
            this.inView = entries.some(function (e) { return e.isIntersecting; });
          }.bind(this), { threshold: 0.35 });
          this.io.observe(this);
        }

        if (this.autoplay && !reduceMotion.matches) this.timer = setInterval(this.auto.bind(this), this.interval);

        /* Modo limitado: setas só quando há mais itens do que cabem, sem voltar ao início */
        if (this.hasAttribute('data-vm-bounded')) {
          this.bounded = true;
          this.onTrackScroll = function () {
            if (this.edgeTick) return;
            this.edgeTick = true;
            window.requestAnimationFrame(function () { this.edgeTick = false; this.updateEdges(); }.bind(this));
          }.bind(this);
          this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });
          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(this.onTrackScroll);
            this.ro.observe(this.track);
          } else {
            window.addEventListener('resize', this.onTrackScroll);
          }
          this.updateEdges();
        }

        if (designMode) {
          this.onSelect = function (event) {
            if (!this.track.contains(event.target)) return;
            this.hold(Infinity);
            this.track.scrollTo({ left: Math.max(0, event.target.offsetLeft - this.track.offsetLeft - 2), behavior: 'smooth' });
          }.bind(this);
          this.onDeselect = function (event) { if (this.track.contains(event.target)) this.hold(1500); }.bind(this);
          document.addEventListener('shopify:block:select', this.onSelect);
          document.addEventListener('shopify:block:deselect', this.onDeselect);
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
        if (this.bounded && !this.ro) window.removeEventListener('resize', this.onTrackScroll);
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
        if (this.onDeselect) document.removeEventListener('shopify:block:deselect', this.onDeselect);
      }

      hold(ms) { this.holdUntil = ms === Infinity ? Infinity : Date.now() + ms; }

      stepSize() {
        var card = this.track.querySelector('[data-vm-card]');
        if (!card) return this.track.clientWidth * 0.8;
        var style = window.getComputedStyle(this.track);
        var gap = parseFloat(style.columnGap || style.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      atEnd() { return this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4; }

      updateEdges() {
        var scrollable = this.track.scrollWidth > this.track.clientWidth + 4;
        this.classList.toggle('is-scrollable', scrollable);
        if (this.prevBtn) this.prevBtn.disabled = !scrollable || this.track.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = !scrollable || this.atEnd();
      }

      step(direction, loop) {
        if (this.bounded) loop = false;
        if (loop && direction > 0 && this.atEnd()) { this.track.scrollTo({ left: 0, behavior: 'smooth' }); return; }
        if (loop && direction < 0 && this.track.scrollLeft <= 2) { this.track.scrollTo({ left: this.track.scrollWidth, behavior: 'smooth' }); return; }
        var size = this.bounded ? Math.max(this.stepSize(), this.track.clientWidth * 0.7) : this.stepSize();
        this.track.scrollBy({ left: direction * size, behavior: 'smooth' });
      }

      auto() {
        if (!this.inView || document.hidden) return;
        if (this.holdUntil === Infinity || Date.now() < this.holdUntil) return;
        this.step(1, true);
      }
    });
  }

  /* ------------------------------------------------------------------
     Separadores de filtro (mais vendidos)
     ------------------------------------------------------------------ */
  if (!customElements.get('vm-tabs')) {
    customElements.define('vm-tabs', class VmTabs extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.prototype.slice.call(this.querySelectorAll('[data-vm-tab]'));
        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-vm-group]'));
        this.buttons.forEach(function (button) {
          button.addEventListener('click', function () { this.select(button.dataset.vmTab); }.bind(this));
        }, this);
        if (designMode) {
          this.onSelect = function (event) {
            if (this.cards.indexOf(event.target) > -1 && event.target.hidden) this.select('todos');
          }.bind(this);
          document.addEventListener('shopify:block:select', this.onSelect);
        }
      }

      disconnectedCallback() {
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
      }

      select(key) {
        this.buttons.forEach(function (button) {
          button.setAttribute('aria-pressed', button.dataset.vmTab === key ? 'true' : 'false');
        });
        this.cards.forEach(function (card) {
          card.hidden = !(key === 'todos' || card.dataset.vmGroup === key);
        });
      }
    });
  }

  /* ------------------------------------------------------------------
     Atalhos para as secções da página inicial, sem "#" no endereço
     ------------------------------------------------------------------ */
  if (!window.__vmScrollLinks) {
    window.__vmScrollLinks = true;
    var vmGoTo = function (target, smooth) {
      target.scrollIntoView({ behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto', block: 'start' });
      if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
        target.style.outline = 'none';
      }
      try { target.focus({ preventScroll: true }); } catch (e) {}
    };
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target && event.target.closest ? event.target.closest('[data-vm-scroll]') : null;
      if (!link) return;
      var target = document.getElementById(link.getAttribute('data-vm-scroll'));
      if (!target) return;
      event.preventDefault();
      vmGoTo(target, true);
    });
    /* Endereços antigos com #categoria: vai à secção e limpa o endereço */
    if (window.location.hash && window.history && window.history.replaceState) {
      var vmHashId = '';
      try { vmHashId = decodeURIComponent(window.location.hash.slice(1)); } catch (e) {}
      var vmHashTarget = vmHashId ? document.getElementById(vmHashId) : null;
      if (vmHashTarget && vmHashTarget.classList.contains('vm-cat')) {
        window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
        window.addEventListener('load', function () { vmGoTo(vmHashTarget, false); });
      }
    }
  }

  /* ------------------------------------------------------------------
     Confirmação visual "Adicionado" nos botões vm-atc
     ------------------------------------------------------------------ */
  if (!window.__vmAtcFeedback) {
    window.__vmAtcFeedback = true;
    onCartUpdate(function (event) {
      if (!event || event.source !== 'product-form') return;
      var id = String(event.productVariantId || '');
      Array.prototype.forEach.call(document.querySelectorAll('.vm-atc'), function (form) {
        var input = form.querySelector('input[name="id"]');
        var button = form.querySelector('button[type="submit"]');
        if (!input || !button || String(input.value) !== id) return;
        var label = button.querySelector('.vm-atc__label') || button.querySelector('span');
        if (!label) return;
        if (button.vmLabelHtml == null) button.vmLabelHtml = label.innerHTML;
        label.textContent = button.dataset.vmAddedLabel || '✓ Adicionado';
        button.classList.add('is-added');
        clearTimeout(button.vmTimer);
        button.vmTimer = setTimeout(function () {
          label.innerHTML = button.vmLabelHtml;
          button.classList.remove('is-added');
        }, 2400);
      });
    });
  }

  /* ------------------------------------------------------------------
     Embalagens do mesmo tamanho nos cartões de produto.
     As fotos conhecidas já trazem as medidas no HTML (vm-mas-vendidos);
     as fotos novas são medidas aqui, uma vez, pela parte não transparente.
     ------------------------------------------------------------------ */
  if (window.CSS && CSS.supports && CSS.supports('container-type', 'size')) {
    var vmMeasurePack = function (img) {
      if (img.vmFitDone || img.style.getPropertyValue('--fw')) return;
      img.vmFitDone = true;
      var run = function () {
        try {
          var w = img.naturalWidth, h = img.naturalHeight;
          if (!w || !h) return;
          var W = 120, H = Math.max(1, Math.round(W * h / w));
          var canvas = document.createElement('canvas');
          canvas.width = W; canvas.height = H;
          var ctx = canvas.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(img, 0, 0, W, H);
          var d = ctx.getImageData(0, 0, W, H).data;
          var x0 = W, y0 = H, x1 = -1, y1 = -1, solid = 0;
          for (var y = 0; y < H; y++) {
            for (var x = 0; x < W; x++) {
              var a = d[(y * W + x) * 4 + 3];
              if (a > 250) solid++;
              if (a > 96) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
            }
          }
          if (x1 < 0 || solid === W * H) return; /* foto sem fundo transparente: fica como está */
          var r = function (v) { return String(Math.round(v * 10000) / 10000); };
          img.style.setProperty('--fw', r((x1 + 1 - x0) / W));
          img.style.setProperty('--fh', r((y1 + 1 - y0) / H));
          img.style.setProperty('--fr', r(w / h));
          img.style.setProperty('--fx', r((x0 + x1 + 1) / 2 / W));
          img.style.setProperty('--fy', r((y0 + y1 + 1) / 2 / H));
        } catch (e) { /* foto de outro domínio: fica como está */ }
      };
      if (img.complete && img.naturalWidth) run(); else img.addEventListener('load', run, { once: true });
    };
    var vmScanPacks = function (root) {
      Array.prototype.forEach.call((root || document).querySelectorAll('.vm-pcard__img'), vmMeasurePack);
    };
    vmScanPacks();
    document.addEventListener('shopify:section:load', function (event) { vmScanPacks(event.target); });
  }
})();
